import {breakpoint} from "../../utils/mediaQueries.obj";

// Objet global pour les variables de base du CMS
// cmsCore est initialisé dans l'entête de la page
cmsCore = {
    smallmobile: breakpoint.breakpoint_tiny,
    mobile: breakpoint.breakpoint_small,
    tablet: breakpoint.breakpoint_medium,
    desktop: breakpoint.breakpoint_large,
    tv: breakpoint.breakpoint_huge,
    title_newwindow: (cmsCore.title_newwindow ? cmsCore.title_newwindow : ''),
    SIT_IMAGE: (cmsCore.SIT_IMAGE ? cmsCore.SIT_IMAGE : ''),
    postMaxSize: (cmsCore.postMaxSize ? cmsCore.postMaxSize : 0),
}
